import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ActivityService } from 'src/app/service/activity.service';
import { AgentService } from 'src/app/service/agent.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { DataService } from 'src/app/service/data.service';
import { EventService } from 'src/app/service/event.service';
import { SoftwareInventoryService } from 'src/app/service/software-inventory.service';
import { SolutionService } from 'src/app/service/solution.service';
import { Events, MsgPayLoad, WebsocketService } from 'src/app/service/websocket.service';
import { Modal } from '../controls/modal/modal.service';
import { ProductDataType, ProductsComponent, ProductTreeType } from '../products/products.component';
import { CSRegisteredServerCheck, DiscoveredProduct, GetPatchRemovalActivityRequest, PatchExt, PatchRemovalActivity, ProductExt, ProductInstance } from 'src/app/model/Product';
import { Agent } from 'src/app/model/Agent';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';
import { ActionMenuEvent, ActionMenuIcon, ActionMenuItem } from '../controls/actionmenu/action-menu.component';
import { LanguagePack } from 'src/app/model/CatalogProduct';
import { ColumnSort, ColumnType, DataTableColumn, DataTableRow } from '../controls/datatable/datatable.component';
import { Tab, TabColor } from '../controls/tabs/tabs.component';
import { Utils } from 'src/app/utils';
import { WizardStep } from '../controls/wizard/wizard.component';
import { ModalMessageComponent, ModalMessageType } from '../controls/modal-message/modal-message.component';
import { PackageRow } from '../systems-enable/systems-enable.component';
import { DownloadItem } from '../products-overview/products-overview.component';
import { UserInfo } from 'src/app/model/User';
import { DownloadType } from 'src/app/model/DownloadStatus';
import { CSProductInfo } from '../dialogs/login-cs/login-cs.component';
import { TranslationUtils } from 'src/app/app-translation-utils';
import { ActivityCapabilitiesType, ActivityTask, ActivityTaskType, PreFlightCheck, PreFlightCheckType, PreFlightProgress, PreFlightProgressTask, TaskStatus } from 'src/app/model/TaskStatus';
import { PreFlightRequest } from 'src/app/model/PreFlightRequest';
import { UpgradePrompt } from '../products-details/products-details.component';
import { PreReqCsErrorComponent } from '../dialogs/pre-req-cs-error/pre-req-cs-error.component';
import { UploadFileType } from 'src/app/model/Upload';
import { DragDropComponent, UploadModalData } from '../dialogs/drag-drop/drag-drop.component';
import { ObjectDetailsComponent, ObjectDetailsTypes } from '../dialogs/object-details/object-details.component';
import { DeployUpdateComponent,  DeployUpdateResult } from '../dialogs/deploy-update/deploy-update.component';

enum Tabs {
  PATCHES
}

enum ProductInstalledState {
  SELECT = "SELECT",
  DOWNLOAD = "DOWNLOAD",
  REVIEW = "REVIEW",
  VALIDATE = "VALIDATE",
  REMOVE = "REMOVE",
}

@Component({
  selector: 'app-products-installed',
  templateUrl: './products-installed.component.html',
  styleUrl: './products-installed.component.css',
  standalone: false
})
export class ProductsInstalledComponent extends ProductsComponent implements OnInit, OnDestroy {

  ProductInstalledState = ProductInstalledState;
  state: ProductInstalledState = ProductInstalledState.SELECT;
  steps: WizardStep[] = [];
  stepIndex: number = 0;
  nextButton: string = $localize`Next`;

  Tabs = Tabs;
  TabColor = TabColor;
  patchesTab = new Tab('product-installed-patches-tab', $localize`Patches`, 0, false);
  installedTabs: Tab[] = [this.patchesTab];
  activeTab: number = 0;

  isError: boolean = false;
  isOnlineMode: boolean = false;
  isLoadingMissing: boolean = false;
  isPrimarySystemSupported: boolean = false;
  isPrimarySystemSelected: boolean = false;
  isPrimarySystemOnline: boolean = false;
  isAgentOnline: boolean = false;
  isQuickAnalysisRequired: boolean = false;
  isAvailablePatches: boolean = false;
  isRequestingPatches: boolean = false;
  isProxyRequired: boolean = false;
  isDownloadStarted: boolean = false;
  isDownloading: boolean = false;
  isValidated: boolean = false;
  isValidating: boolean = false;
  isValidationWarning: boolean = false;
  isActivityRunning: boolean = false;
  isWaitingForActivityCapabilities: boolean = false;
  patchesLoading: boolean = false;
  requestFailed: boolean = false;
  needsDownload: boolean = false;
  showRetry: boolean = false;
  isExportBtnClicked: boolean = false;
  recountSelectedRow: boolean = false;
  needsDetails: boolean = false;
  taskInProgress: boolean = false;

  user: UserInfo;

  agents: Agent[] = [];
  discoveredProduct: DiscoveredProduct[] = [];

  availablePatches: PatchExt[];
  selectedComponentVersion: string;
  activeUpdate: PatchExt;
  activeProduct: ProductExt;

  primaryHost: string;
  primaryInstance: ProductInstance;
  csInfo: CSProductInfo;
  requestErrorMessage: string;

  productGroupId: number;
  platform: string;
  binaryuid: string;
  currEnvId: number;
  setupId: string;
  host: string;

  productDetailsTitle: string;
  headerTitle: string;

  summaryVersion: string;
  summaryStatus: string;
  summaryDescription: string;
  summarySize: string;
  summaryReleaseDate: string;
  summaryZeroDowntime: boolean;

  hotfixTableCols: DataTableColumn[] = [];
  hotfixTableRows: DataTableRow[] = [];

  productInstalledTableCols: DataTableColumn[];
  productInstalledTableRows: DataTableRow[];

  removeList: string[] = [];
  removePackageList: PatchExt[] = [];

  showRemoveHotfix: boolean = false;
  waitingForRemoveActivity: boolean = false;
  patchRemovalActivity: PatchRemovalActivity;

  instanceCount: number = 0;

  missingItemsToReApply: PatchExt[] = [];
  missingPackageRows: DataTableRow[] = [];
  missingPackageCols: DataTableColumn[] = [];
  signInCancelled: boolean = false;
  patchesToRemove: PatchExt[] = [];
  updateToInstall: PatchExt;
  patchesToInstall: PatchExt[] = [];
  langPacksToInstall: LanguagePack[] = [];

  itemsToDownload: DownloadItem;
  removeItemsCols: DataTableColumn[] = Array<DataTableColumn>(
    new DataTableColumn("installType", $localize`Install Type`, ColumnType.STRING, false, "25"),
    new DataTableColumn("type", $localize`Type`, ColumnType.STRING, false, "25"),
    new DataTableColumn("name", $localize`Name`, ColumnType.STRING, false, "50"),
  );
  removeItemsRows: DataTableRow[] = [];
  isRemoveItemsReady: boolean = false;

  registeredServersTask: TaskStatus;
  registeredServerError: string;
  registeredServerCheck: CSRegisteredServerCheck;

  instancesTab = new Tab('instances-tab', $localize`Instances`, undefined, false);
  validateTabs: Tab[] = [this.instancesTab];
  validationTableCols: DataTableColumn[] = Array<DataTableColumn>(
    new DataTableColumn("system", $localize`System`, ColumnType.STRING, true, "28.5", ColumnSort.DESC),
    new DataTableColumn("installPath", $localize`Install path`, ColumnType.STRING, false, "21.5"),
    new DataTableColumn("version", $localize`Version`, ColumnType.STRING, false, "13"),
    new DataTableColumn("platform", $localize`Platform`, ColumnType.STRING, false, "17"),
    new DataTableColumn("actions", $localize`Actions`, ColumnType.LINK, false, "20"),
  );
  validationTableLoading: boolean = true;

  preFlightRequest: PreFlightRequest;
  canInstallWithZeroDownTime: boolean = false;
  analysisVersion: string;
  isSendingPatchRemoval: boolean = false;
  isTitleSet: boolean = false;

  constructor(protected eventService: EventService,
    protected authService: AuthenticationService,
    protected siService: SoftwareInventoryService,
    protected dataService: DataService,
    protected wsService: WebsocketService,
    protected router: Router,
    protected modal: Modal,
    protected activityService: ActivityService,
    protected route: ActivatedRoute,
    private cookieSrv: CookieService,
    protected agentService: AgentService,
    protected solutionService: SolutionService) {
    super(eventService, authService, siService, dataService, wsService, router, modal, activityService, solutionService);
  }

  ngOnInit(): void {
    this.needsDetails = true;
    this.isQuickAnalysisRequired = true;
    this.isOnlineMode = this.authService.getLoggedInUser().settings.isOnlineMode;

    this.routeSubscription = this.route.params.subscribe(params => {
      this.isReload = this.productId !== undefined;
      this.productId = +params['productId'];
      this.isLoading = true;
      if (this.isReload) {
        this.activeProduct = undefined;
        this.activeUpdate = undefined;
        this.isQuickAnalysisRequired = true;
        this.isAvailablePatches = false;
      }
    });

    this.dataSubscription = this.dataService.getData().subscribe((data: any) => {
      if (data) {
        switch (data.type) {
          case (ProductDataType.AgentManifest):
            this.isAgentManifestUpdating = data.isAgentManifestUpdating;
            break;
          case (ProductDataType.QuickAnalysis):
            this.processDataServiceGeneral(data);
            break;
          case (ProductDataType.General):
            this.processDataServiceGeneral(data);
            break;
          case (ProductDataType.Updates):
            this.processDataServiceUpdates(data);
            break;
          case (ProductDataType.DownloadStarted):
            if (this.isDownloadStarted) {
              this.setDownloadInProgress();
            }
            break;
          case (ProductDataType.ProductLogin):
            this.processProductLoginResult(data.result);
            break;
          case (ProductDataType.Transaction):
            this.addTransactionId(data.id);
            break;
        }
      }
    });

    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      switch (msg.eventType) {
        case Events.GetPatchRemovalActivity:
          if (this.isPendingTransaction(msg.headers.transactionId, true)) {
            this.processPatchRemovalActivity(msg.body.msg);
          }
          break;
        case Events.DownloadCompleted:
          if (this.state == ProductInstalledState.DOWNLOAD) {
            this.processDownloadComplete(msg);
          }
          break;
        case Events.CSRegisteredServers:
          if (this.isPendingTransaction(msg.headers.transactionId, true)) {
            this.processRegisteredServersResponse(msg);
          }
          break;
        case Events.CSPreFlight:
        case Events.CSPreFlightProgress:
          if (this.isPendingTransaction(msg.headers.transactionId, false)) {
            this.processPreFlightMessage(msg);
          }
          break;
        case Events.ActivityCapabilities:
          if (this.isPendingTransaction(msg.headers.transactionId, true)) {
            this.processActivityCapabilities(msg);
          }
          break;
        case Events.ActivityRefresh:
        case Events.ActivityTaskStatus:
          this.isPatchRemovalInProgress(false);
          break;
        case Events.AgentStatusOffline:
        case Events.AgentStatusOnline:
          this.isReload = true;
        break;
      }
    });
  }

  ngOnDestroy() {
    if (this.routeSubscription != undefined) {
      this.routeSubscription.unsubscribe();
    }
    if (this.dataSubscription != undefined) {
      this.dataSubscription.unsubscribe();
    }
    if (this.eventMessageSubscription != undefined) {
      this.eventMessageSubscription.unsubscribe();
    }
  }

  setDefault(): void {
    this.updateToInstall = undefined;
    this.patchesToInstall = [];
    this.patchesToRemove = [];
    this.langPacksToInstall = [];
    this.missingItemsToReApply = [];
    this.preReqTableRows = [];
    this.removeItemsRows = [];
    this.missingPackageRows = [];
    this.hotfixTableRows = [];
    this.activeProduct = undefined;
    this.activeUpdate = undefined;
    this.isTitleSet = false;
    this.removeList = [];
    this.removePackageList = [];
    this.setState(ProductInstalledState.SELECT);
    this.activeTab = 0;
  }

  initView(): void {
    this.isReload = false;
    this.currEnvId = this.solutionInfo.currentEnvironment.id;
    this.steps = [{ 'id': ProductInstalledState.SELECT, 'name': $localize`Select` }];
    this.steps.push({ 'id': ProductInstalledState.DOWNLOAD, 'name': $localize`Download` });
    this.steps.push({ 'id': ProductInstalledState.REVIEW, 'name': $localize`Review` });
    this.steps.push({ 'id': ProductInstalledState.VALIDATE, 'name': $localize`Validate` });
    this.steps.push({ 'id': ProductInstalledState.REMOVE, 'name': $localize`Remove` });
    this.dataService.sendData({ type: ProductDataType.Title, title: $localize`Installed patches` });
    this.getProductDetails();
  }

  initColumns(): void {
    this.productInstalledTableCols = this.activeProduct.supportHotfix ? Array<DataTableColumn>(new DataTableColumn("name", $localize`Name`, ColumnType.STRING, false, "12"),
      new DataTableColumn("description", $localize`Description`, ColumnType.STRING, false, "44"),
      new DataTableColumn("module", $localize`Modules`, ColumnType.STRING, false, "26"),
      new DataTableColumn("zero", $localize`Zero Downtime`, ColumnType.STRING, false, "10"),
      new DataTableColumn("status", $localize`Status`, ColumnType.STATUSEXT, false, "8")) :
      Array<DataTableColumn>(new DataTableColumn("name", $localize`Name`, ColumnType.STRING, false, "30"),
        new DataTableColumn("description", $localize`Description`, ColumnType.STRING, false, "55"),
        new DataTableColumn("status", $localize`Status`, ColumnType.STATUSEXT, false, "15"));

    this.missingPackageCols = this.isOnlineMode ?
      Array<DataTableColumn>(
        new DataTableColumn('displayType', $localize`Type`, ColumnType.STRING, true, "25"),
        new DataTableColumn('name', $localize`Name`, ColumnType.STRING, false, "50"),
        new DataTableColumn('status', $localize`Status`, ColumnType.STATUSEXT, false, "25")
      ) :
      Array<DataTableColumn>(
        new DataTableColumn('displayType', $localize`Type`, ColumnType.STRING, true, "25"),
        new DataTableColumn('name', $localize`Name`, ColumnType.STRING, false, "40"),
        new DataTableColumn('status', $localize`Status`, ColumnType.STATUSEXT, false, "25"),
        new DataTableColumn("url", $localize`URL`, ColumnType.DOWNLOADLINK, false, "10")
      );
  }

  setState(newState: ProductInstalledState): void {
    this.requestFailed = false;
    this.requestErrorMessage = "";
    this.showRetry = false;
    this.state = newState;
    this.nextButton = this.state == ProductInstalledState.REMOVE ? $localize`Finish` : $localize`Next`;
    let index: number = this.steps.findIndex(s => {
      return s.id == this.state;
    });

    this.stepIndex = index > -1 ? index : 0;
  }

  goToPrevState(): void {
    switch (this.state) {
      case ProductInstalledState.DOWNLOAD:
        this.goToSelect();
        break;
      case ProductInstalledState.REVIEW:
        this.goToDownload(true);
        break;
      case ProductInstalledState.VALIDATE:
        this.goToReview();
        break;
      case ProductInstalledState.REMOVE:
        this.goToValidate();
        break;
    }
  }

  goToNextState(): void {
    switch (this.state) {
      case ProductInstalledState.SELECT:
        this.getPatchRemovalActivity();
        break;
      case ProductInstalledState.DOWNLOAD:
        this.goToReview();
        break;
      case ProductInstalledState.REVIEW:
        this.goToValidate();
        break;
      case ProductInstalledState.VALIDATE:
        this.goToRemove();
        break;
      case ProductInstalledState.REMOVE:
        this.goToFinish();
        break;
    }
  }

  goToSelect(): void {
    this.setState(ProductInstalledState.SELECT);
  }

  goToDownload(isBack: boolean): void {
    if (isBack) {
      this.goToSelect();
    } else {
      this.setState(ProductInstalledState.DOWNLOAD);
    }
  }

  goToReview(): void {
    this.setState(ProductInstalledState.REVIEW);
    this.processItemsForReview();
  }

  goToRemove(): void {
    this.showPatchRemovalWarning();
  }

  goToValidate(): void {
    this.setState(ProductInstalledState.VALIDATE);
    this.loadInstances();
    this.validateRemovalRequest();
  }

  goToFinish(): void {
    this.startPatchRemoval();
  }

  cancelDeploymentWizard(): void {
    this.goToOverview();
  }

  isDisableNextBtn(): boolean {
    let isDisabled: boolean = false;
    if (this.isAgentOnline && !this.taskInProgress) {
      switch (this.state) {
        case ProductInstalledState.SELECT:
          isDisabled = this.removeList.length == 0 || this.waitingForRemoveActivity;
          break;
        case ProductInstalledState.DOWNLOAD:
          isDisabled = this.isError || this.missingPackageRows.length > 0 || this.isDownloading;
          break;
        case ProductInstalledState.VALIDATE:
          isDisabled = this.isError || this.isValidating || this.requestFailed;
          break;
        case ProductInstalledState.REMOVE:
          isDisabled = this.requestFailed || this.isSendingPatchRemoval;
          break;
      }
    } else {
      isDisabled = true;
    }

    return isDisabled;
  }

  showNextProgressSpinner(): boolean {
    return this.waitingForRemoveActivity;
  }

  goToOverview(): void {
    this.router.navigate(['products/overview']);
  }

  getProduct(data: any): ProductExt {
    let foundProduct: ProductExt;
    const discoveredProductGroup: DiscoveredProduct[] = data.discoveredProductGroup;

    //get platform
    for (let i = 0; i < discoveredProductGroup.length; i++) {

      let foundProd: ProductExt[] = (discoveredProductGroup[i].products.filter((prod: ProductExt) => {
        return prod.id == this.productId;
      }));

      if (foundProd.length > 0) {
        foundProduct = foundProd[0];
        break;
      }
    }

    return foundProduct;
  }

  getProductDetails(): void {
    if (this.isAgentOnline && this.quickAnalysisResult == undefined && this.isQuickAnalysisRequired) {
      setTimeout(() => {
        this.getProductDetails();
      }, 50);
    } else {
      this.siService.getProductDetail(this.currEnvId, this.platform, this.productId).pipe(
        tap(resp => {
        this.activeProduct = resp.body;
        this.initColumns();
        if (this.availablePatches !== undefined) {
          this.initActiveUpdate(this.activeProduct.supportHotfix);
        }
        setTimeout(() => {
          this.isPatchRemovalInProgress(false);
        }, 0);
        this.isLoading = false;
        })).subscribe();
    }
  }

  processDataServiceGeneral(data: any): void {
    let product: ProductExt;
    this.solutionInfo = data.solutionInfo;
    this.isAgentOnline = data.isAgentOnline;
    this.isManifestUpdating = this.solutionInfo.manifestStatus.isUpdating;
    this.isAgentManifestUpdating = data.isAgentManifestUpdating;

    this.isReload = (this.isReload ||
      (this.currEnvId != this.solutionInfo.currentEnvironment.id) ||
      (this.currEnvId !== undefined && this.currEnvId != this.solutionInfo.currentEnvironment.id)
    );

    product = this.getProduct(data);

    if (product) {

      if ((product.zeroDownTimeMinVersion == undefined || product.zeroDownTimeMinVersion == "") ||
          (product.zeroDownTimeMinVersion !== undefined && product.zeroDownTimeMinVersion !== ""  
            && !Utils.isVersionOrHigher(product.zeroDownTimeMinVersion, product.version))) {
        this.goToOverview();
      }

      if (!this.isTitleSet) {
        this.isTitleSet = true;
        this.dataService.sendData({
            type: ProductDataType.SelectTree, select: {
            type: ProductTreeType.INSTALLED_PATCHES,
            productGroupId: product.groupId, productId: product.id
          }
        });
      }

      if (data.type == ProductDataType.QuickAnalysis) {
        this.quickAnalysisResult = data.quickAnalysisResult;
        this.isQuickAnalysisRequired = (product.requiresQuickAnalysis && (data.quickAnalysisResult == undefined || !data.quickAnalysisResult.isValid));
      }
      
      this.platform = product.platform;
      this.setupId = product.components[0].setupid;
      this.isAgentOnline = product.isMasterSystemOnline;
      this.isPrimarySystemSupported = product.requiresPrimarySystem;

      Object.keys(product.instances).forEach(host => {
        this.instanceCount += product.instances[host].length;
      });

      if(this.primaryHost == undefined) {
        for (let i = 0; i < Object.keys(product.instances).length; i++) {
          let key: string = Object.keys(product.instances)[i];
          for (let j = 0; j < product.instances[key].length; j++) {
            if (product.instances[key][j].isMasterInstance) {
              this.isPrimarySystemSelected = true;
              this.primaryHost = key;
              this.primaryInstance = product.instances[key][j];
              break;
            }
          }
          if (this.primaryHost) {
            break;
          }
        }
      }
    }

    if(this.platform && this.isReload){
      this.setDefault();
      this.initView();
      this.isReload = false;
    }else if(this.platform == undefined){
      this.goToOverview();
    }
  }

  processDataServiceUpdates(data: any): void {
    let product: ProductExt = this.getProduct(data);
    if (product !== undefined) {
      this.availablePatches = product.availablePatches;
      if(this.activeProduct) {
        this.initActiveUpdate(product.supportHotfix);
      }
    }
  }

  processActivityCapabilities(msg: MsgPayLoad): void {
    this.activityCapabilities = JSON.parse(msg.body.msg);
    if (this.activityCapabilities.activityType == ActivityCapabilitiesType.ENABLE_PRODUCT) {
      this.activityCapabilities.tasks.forEach((task: ActivityTask) => {
        if (task.type == ActivityTaskType.VALIDATE_HOST) {
          task.completed = true;
          task.success = true;
          task.isCurrentTask = false;
        } else if (task.type == ActivityTaskType.VALIDATE_COMMUNICATIONS) {
          task.completed = true;
          task.success = true;
          task.isCurrentTask = true;
        } else {
          task.isCurrentTask = false;
        }
      });

      this.analyzeMasterSystem(this.solutionInfo, this.activityCapabilities, this.activeProduct);
    }
  }

  initActiveUpdate(isLoadHotfix: boolean): void {
    let update: PatchExt;
    let updateIndex: number = 0;

    let foundUpdate = this.availablePatches.filter((patch: PatchExt, index: number) => {
      if (patch.details && (patch.details.binaryuid == this.activeProduct.updateBinaryUid)) {
        updateIndex = index;
        return patch;
      }
    });

    if (foundUpdate.length > 0) {
      update = foundUpdate[0];
      if (update.details && update.details.languagePackList && update.details.languagePackList.length > 0) {
        update.details.languagePackList.forEach((langpack) => {
          langpack.updateBinaryUID = update.details.binaryuid;
        });
      }
    }

    if (update) {
      this.availablePatches.forEach((update: PatchExt, index: number) => {
        if (index == 0 && this.activeProduct.supportHotfix) {
          update.status = 'INSTALLED';
        } else if (update.status == 'INSTALLED') {
          update.status = 'COMPLETE';
        }
      });

      this.setActiveUpdate(update);

      if (this.activeProduct.supportHotfix && isLoadHotfix) {
        this.hotfixTableRows = [];
        this.requestFailed = false;
        this.patchesLoading = true;
        this.validateInstalledPatches();
      }
    }
  }

  setActiveUpdate(update: PatchExt): void {
    this.activeUpdate = update;
    this.summaryStatus = this.activeUpdate.status;
    this.summaryVersion = this.activeUpdate.isSupportHotfix ? this.activeUpdate.name : this.activeUpdate.patchLevel;
    this.summaryZeroDowntime = this.activeUpdate.supportsZeroDowntime;

    if (this.activeUpdate.details) {
      this.headerTitle = this.activeUpdate.name;
      this.summaryDescription = this.activeUpdate.details.description;
      this.summarySize = this.activeUpdate.details.size;
      this.summaryReleaseDate = this.activeUpdate.details.publishDate;
    }

    this.dataService.sendData({ type: ProductDataType.Title, title: $localize`Installed patches for ${this.activeProduct.name} ${this.activeProduct.version}` });
  }

  analyzeMasterSystemClicked(): void {
    this.getEnableProductCapabilities(this.solutionInfo, this.activityCapabilities, this.activeProduct);
  }

  onSelectedTabChange(selectedIndex: number) {
    this.activeTab = selectedIndex;
  }

  validateInstalledPatches(): void {
    this.productInstalledTableRows = [];
    if (this.activeProduct.installedPatches && this.activeProduct.installedPatches.length > 0) {
      this.activeProduct.installedPatches.sort((a, b) => (a.id < b.id ? -1 : 1));
      this.activeProduct.installedPatches.forEach((patch: PatchExt) => {
        
        if(this.isPatchDeprecated(patch)) {
          patch.status = 'DEPRECATED';
        }
        
        let status = this.getStatus(patch);
        let actionMenuItems: ActionMenuItem[] = patch.status !== 'UNKNOWN' ? [new ActionMenuItem("Details", $localize`Details`, ActionMenuIcon.DETAILS, patch, false, true)] : [];
        let moduleList: string = Utils.getModuleList(patch.details);
        let tmpRow: DataTableRow = new DataTableRow({
          name: patch.name, description: patch.description,
          module: moduleList, status: status, patch: patch,
          zero: (patch.zero) ? $localize`Supported` : ""
        }, actionMenuItems, undefined);

        if (moduleList !== undefined && moduleList.length > 0) {
          tmpRow.disableCheckbox = true;
        }

        if (!patch.zero) {
          tmpRow.disableCheckbox = true;
        }

        this.productInstalledTableRows.push(tmpRow);
      });
    }
    this.patchesTab.count = this.productInstalledTableRows.length;

    this.patchesLoading = false;
  }

  isPatchDeprecated(patch: PatchExt): boolean {
    let isDeprecated: boolean = false;
    //check for a module patch
    if (patch.details && patch.details.modules && patch.details.modules.length > 0) {
      //no modules installed
      if (this.quickAnalysisResult.modules.length == 0) {
        isDeprecated = true;
        //is the module installed?
      } else {
        let isModuleInstalled: boolean = false;

        for (var i = 0; i < patch.details.modules.length; i++) {
          let index: number = this.quickAnalysisResult.modules.findIndex(module => (module.name === patch.details.modules[i].name) && (module.version === patch.details.modules[i].version));
          //is the module installed?
          if (index > -1) {
            isModuleInstalled = true;
            break;
          }
        }

        //module not found
        if (!isModuleInstalled) {
          isDeprecated = true;
        }
      }
    }

    //check for a deprecated patch
    if (patch.details && patch.details.removedInUpdateLevel) {
      if (+patch.details.removedInUpdateLevel <= +this.activeUpdate.patchLevel) {
        isDeprecated = true;
      }
    }

    //check for retired patch (Upgrading and installed patch is retired)
    if (patch.details && patch.details.retired) {
      isDeprecated = true;
    }

    return isDeprecated;
  }

  getStatus(patch): any {
    let status: any;

    if (patch.status === 'KNOWN') {
      status = { className: 'otsc-icon-status-available', altText: $localize`This is a known patch` }
    } else if (patch.status === 'UNKNOWN') {
      status = { className: 'otsc-icon-status-error', altText: $localize`This is an unknown patch` }
    } else if (patch.status === 'DEPRECATED') {
      status = { className: 'otsc-icon-status-outdated', altText: $localize`This is a deprecated patch` }
    }

    return status;
  }

  selectAllHotfix(rows: DataTableRow[]): void {
    rows.forEach((row: DataTableRow) => {
      this.selectHotfix(row, true);
    });
  }

  selectSingleHotfix(row: DataTableRow): void {
    this.selectHotfix(row, false);
  }

  selectHotfix(row: DataTableRow, selectAll: boolean): void {
    if(!row.disableCheckbox) {
      let currentName: string = row.data.patch.details.id;
      let dependentRows: DataTableRow[] = [];
      let triggerRecount: boolean = false;

      dependentRows = this.productInstalledTableRows.filter((row: DataTableRow) => {
        let dependsOn: boolean = false;
        if (row.data.patch.details && row.data.patch.details.dependents.length > 0) {
          for (let i = 0; i < row.data.patch.details.dependents.length; i++) {
            if (row.data.patch.details.dependents[i].id == currentName) {
              dependsOn = true;
              break;
            }
          }
        }
        return dependsOn;
      });

      if (row.selected) {
        if (!row.disableCheckbox && this.removeList.findIndex(p => p == row.data.name) == -1) {
          if (dependentRows !== undefined && dependentRows.length > 0) {
            triggerRecount = true;
            dependentRows.forEach((dependentRow: DataTableRow) => {
              dependentRow.disableCheckbox = true;
              dependentRow.selected = true;
              this.removePackageList.push(dependentRow.data.patch);
              this.removeList.push(dependentRow.data.name);
            });
          }

          this.removePackageList.push(row.data.patch);
          this.removeList.push(row.data.name);
        }
      } else {
        if (dependentRows !== undefined && dependentRows.length > 0) {
          triggerRecount = true;
          dependentRows.forEach((dependentRow: DataTableRow) => {
            dependentRow.disableCheckbox = false;
            if (selectAll) {
              dependentRow.selected = false;
              this.deleteFromToRemoveList(dependentRow.data);
            }
          });
        }
        this.deleteFromToRemoveList(row.data);
      }

      if (triggerRecount) {
        setTimeout(() => {
          this.recountSelectedRow = !this.recountSelectedRow;
        }, 0);
      }
    } 
  }

  deleteFromToRemoveList(patch: PatchExt) {
    let index: number = this.removeList.findIndex(p => p == patch.name);
    if (index > -1) {
      this.removePackageList.splice(index, 1);
      this.removeList.splice(index, 1);
    }
  }

  getPatchRemovalActivity(): void {
    this.waitingForRemoveActivity = true;
    this.siService.sendGetPatchRemoveActivity(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
      new GetPatchRemovalActivityRequest(this.primaryHost, this.primaryInstance.installPath, this.activeProduct.groupId, this.activeProduct.version,
        this.removeList, this.activeProduct.pluginId)).pipe(
          tap(resp => {
            //nothing to do here
          }),
          finalize(() => {
            this.waitingForRemoveActivity = true;
          })
        ).subscribe();
  }

  processPatchRemovalActivity(data: any): void {
    this.patchRemovalActivity = JSON.parse(data);
    this.patchRemovalActivity.instances = this.activeProduct.instances;
    this.patchRemovalActivity.updateId = this.activeUpdate.id;
    this.patchRemovalActivity.updateBinaryUid = this.activeUpdate.details.binaryuid;
    this.patchRemovalActivity.group = this.activeUpdate.productGroupId;
    this.waitingForRemoveActivity = false;

    if (this.patchRemovalActivity.filesToReplaceFromUpdate.length > 0 ||
      this.patchRemovalActivity.patchesToReApply.length > 0) {
      this.sendValidatePackageRequest();
      this.goToDownload(false);
    } else {
      this.goToReview();
    }
  }

  sendValidatePackageRequest(): void {
    this.isLoadingMissing = true;
    this.needsDownload = false;
    this.missingPackageRows = [];
    this.instanceCount = 0;

    let langCodes: string[] = [];
    if (this.patchRemovalActivity.languagesToReApply.length > 0) {
      this.patchRemovalActivity.languagesToReApply.forEach(lang => {
        langCodes.push(lang.langCode);
      });
    }

    let patchesToInstall: string[] = [];
    if (this.patchRemovalActivity.patchesToReApply.length > 0) {
      this.patchRemovalActivity.patchesToReApply.forEach(patch => {
        patchesToInstall.push(patch.name);
      });
    }

    this.siService.validatePackages(this.solutionInfo.currentEnvironment.id, this.primaryHost,
      this.primaryInstance.installPath, this.activeUpdate.name, this.activeUpdate.patchLevel,
      langCodes, patchesToInstall).pipe(
        tap(resp => {
          this.langPacksToInstall = [];
          this.patchesToInstall = [];
          this.updateToInstall = undefined;
          if (resp.body.success) {
            this.goToNextState();
          } else {
            if (resp.body.dataJson && resp.body.dataJson.missing) {
              if (resp.body.dataJson.missing.update && this.patchRemovalActivity.filesToReplaceFromUpdate.length > 0) {
                this.updateToInstall = resp.body.dataJson.missing.update;
                this.missingItemsToReApply.push(resp.body.dataJson.missing.update);
                let pkgRow: PackageRow = new PackageRow(
                  "missing", "update", $localize`Update`, this.updateToInstall.name, { className: 'otsc-icon-status-outdated', altText: $localize`Missing` }, $localize`Install`,
                  this.updateToInstall);
                pkgRow.url = this.isOnlineMode ? '' : this.updateToInstall.details.downloadURL;
                this.missingPackageRows.push(new DataTableRow(pkgRow, [], false, true, false, ""));
              }
              if (resp.body.dataJson.missing.hotfixes && this.patchRemovalActivity.patchesToReApply.length > 0) {
                resp.body.dataJson.missing.hotfixes.forEach(missingPatch => {
                  this.missingItemsToReApply.push(missingPatch);
                  let pkgRow: PackageRow = new PackageRow(
                    "missing", "patch", $localize`Patch`, missingPatch.name, { className: 'otsc-icon-status-outdated', altText: $localize`Missing` }, $localize`Install`,
                    missingPatch);
                  pkgRow.url = this.isOnlineMode ? '' : missingPatch.details.downloadURL;
                  this.missingPackageRows.push(new DataTableRow(pkgRow, [], false, true, false, ""));
                  if (missingPatch.status)
                    this.patchesToInstall.push(missingPatch);
                });
              }
              if (resp.body.dataJson.missing.langs && this.patchRemovalActivity.languagesToReApply.length > 0) {
                resp.body.dataJson.missing.langs.forEach(missingLangPack => {
                  this.missingItemsToReApply.push(missingLangPack);
                  let pkgRow: PackageRow = new PackageRow(
                    "missing", "lang", $localize`Language Pack`, missingLangPack.langName, { className: 'otsc-icon-status-outdated', altText: $localize`Missing` }, $localize`Install`,
                    missingLangPack);
                  pkgRow.url = this.isOnlineMode ? '' : missingLangPack.downloadURL;
                  this.missingPackageRows.push(new DataTableRow(pkgRow, [], false, true, false, ""));
                  this.langPacksToInstall.push(missingLangPack);
                });
              }
            }
          }
          if (this.missingPackageRows.length > 0) {
            this.needsDownload = true;
          }
          this.isLoadingMissing = false;
        })).subscribe();
  }

  download(): void {
    var user: UserInfo = this.authService.getLoggedInUser();
    this.isOnlineMode = user.settings.isOnlineMode;
    this.isProxyRequired = user.settings.proxyPrompt;
    this.itemsToDownload = new DownloadItem();

    this.missingPackageRows.forEach(row => {
      let pkg = row.data.packageData;
      if (pkg && !pkg.isDownloaded) {
        if (row.data.type == "update") {
          this.itemsToDownload.updates.push(pkg);
        } else if (row.data.type == "patch") {
          this.itemsToDownload.patches.push(pkg);
        } else if (row.data.type == "hotfixes") {
          this.itemsToDownload.patches.push(pkg);
        } else {
          this.itemsToDownload.languages.push(pkg);
        }
      }
    });

    this.isDownloadStarted = true;
    Utils.startDownload(this.isProxyRequired, this.activeProduct.id, this.activeProduct.name,
      this.itemsToDownload, "", this.modal, this.dataService, this.siService);
  }

  setDownloadInProgress(): void {
    this.isDownloading = true;
    let rows: DataTableRow[] = this.missingPackageRows.filter((row: DataTableRow) => {
      return row.data.packageData && row.data.packageData.status != "COMPLETE";
    });

    if (rows.length > 0) {
      rows.forEach(row => {
        row.data.packageData.status = 'DOWNLOAD';
        row.data.status = Utils.getDownloadStatus(row.data.packageData);
      });
    }

    Utils.showDownloadStartedDialog(DownloadType.HOTFIX, this.itemsToDownload.getTotalItems(), this.modal, this.cookieSrv);
  }

  processDownloadComplete(msg: MsgPayLoad): void {
    let id: number = 0;
    let packages: DataTableRow[];
    let activeRows: DataTableRow[];
    let type: string;

    if (msg.body.langPackId > 0) {
      id = msg.body.langPackId;
      type = "lang";
    } else if (msg.body.hotfixId > 0) {
      id = msg.body.hotfixId;
      type = "patch";
    } else if (msg.body.updateId > 0) {
      id = msg.body.updateId;
      type = "update";
    }

    packages = this.missingPackageRows.filter((row: DataTableRow) => {
      if (type == "lang") {
        return row.data.type == type && row.data.packageData.langpackDBId == id;
      } else {
        return row.data.type == type && row.data.packageData.id == id;
      }
    });

    if (packages.length > 0) {
      packages[0].data.packageData.status = "COMPLETE";
      packages[0].data.status = Utils.getDownloadStatus(packages[0].data.packageData);
    }

    activeRows = this.missingPackageRows.filter((row: DataTableRow) => {
      return row.data.packageData && row.data.packageData.status != "COMPLETE";
    });

    if (activeRows.length == 0) {
      this.isDownloadStarted = false;
      this.isDownloading = false;
      this.sendValidatePackageRequest();
    }
  }

  openOfflineUpload(): void {

    this.modal.open(DragDropComponent, {
      data: new UploadModalData(UploadFileType.MISSING, false,
        this.updateToInstall, this.patchesToInstall, this.langPacksToInstall),
      id: 'otsc-drag-drop-dialog',
      customclass: 'ot-modal-side-panel ot-modal-side-panel-md'
    });
  }

  processItemsForReview(): void {
    setTimeout(() => {
      this.removeItemsRows = [];

      this.removeList.forEach(hotfix => {
        this.removeItemsRows.push(new DataTableRow({
          installType: $localize`Remove`,
          name: hotfix,
          type: $localize`Patch`
        }, []));
      });

      if (this.patchRemovalActivity.filesToReplaceFromUpdate.length > 0) {
        this.patchRemovalActivity.filesToReplaceFromUpdate.forEach(file => {
          this.removeItemsRows.push(new DataTableRow({
            installType: $localize`Restore`,
            name: file,
            type: $localize`Update`
          }, []));
        });
      }

      if (this.patchRemovalActivity.languagesToReApply.length > 0) {
        this.patchRemovalActivity.languagesToReApply.forEach(lang => {
          this.removeItemsRows.push(new DataTableRow({
            installType: $localize`Reapply`,
            name: lang.langName,
            type: $localize`Language Pack`
          }, []));
        })
      }

      if (this.patchRemovalActivity.patchesToReApply.length > 0) {
        this.patchRemovalActivity.patchesToReApply.forEach(hotfix => {
          this.removeItemsRows.push(new DataTableRow({
            installType: $localize`Reapply`,
            name: hotfix.name,
            type: $localize`Patch`
          }, []));
        })
      }
      this.isRemoveItemsReady = true;
    }, 0);
  }

  validateActionMenuClicked(event: ActionMenuEvent): void {
    if (event.name === "Retry") {
      this.showLoginDialog();
    }
  }

  actionMenuClicked(event: ActionMenuEvent): void {
    if (event.name === "Details") {
      this.openObjectDetails(event.data[0]);
    }
  }

  rowClick(event: any): void {
    this.openObjectDetails(event.data);
  }

  openObjectDetails(data: any) {
    this.modal.open(ObjectDetailsComponent, {
      data: {
        obj: data.patch ? data.patch : data.languagePack ? data.languagePack : data,
        type: (data.languagePack == undefined) ? ObjectDetailsTypes.PATCH : ObjectDetailsTypes.LANG_PACK
      },
      id: (data.languagePack == undefined) ? 'otsc-products-patch-installed-dialog' : 'otsc-products-langpack-installed-dialog'
    });
  }

  validateRemovalRequest(): void {
    if (this.patchRemovalActivity.requiresValidation) {
      this.isValidating = true;
      if (this.patchRemovalActivity.requiresAuthentication) {
        this.showLoginDialog();
      }
    } else {
      this.goToRemove();
    }
  }

  showLoginDialog(): void {
    this.isValidated = false;
    this.signInCancelled = false;
    this.canInstallWithZeroDownTime = false;
    this.isValidationWarning = false;
    this.isValidating = true;

    Utils.showProductLoginDialog(this.primaryInstance, this.primaryInstance.version, this.activeProduct.version,
      this.activeProduct.pluginId, true, false, this.modal, this.dataService);
  }

  loadInstances(): void {
    if (this.preReqTableRows == undefined || this.preReqTableRows.length == 0) {
      for (let key in this.activeProduct.instances) {
        this.activeProduct.instances[key].forEach((instance: ProductInstance) => {
          let actions: ActionMenuItem[] = [new ActionMenuItem("Retry", $localize`Retry`, ActionMenuIcon.ROLLBACK, instance, true, true)];

          let row: DataTableRow = new DataTableRow({
            system: instance.system,
            installPath: instance.installPath,
            version: instance.version,
            platform: instance.platform,
            instance: instance,
            actions: ''
          }, actions, false, true, false);

          row.disableCheckbox = true;
          this.preReqTableRows.push(row);
        });
      }
    }
  }

  processProductLoginResult(result: any): void {
    this.registeredServerCheck = undefined;
    this.canInstallWithZeroDownTime = false;
    this.isValidationWarning = false;
    this.preFlightRequest = undefined;
    this
    if (result) {
      this.csInfo = result;
      this.checkRegisteredServers();
    } else {
      this.isValidating = false;
      this.signInCancelled = true;
    }
  }

  checkRegisteredServers(isRetry: boolean = false): void {
    this.siService.sendRegisteredServers(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
      this.csInfo.token, this.csInfo.restUrl, this.activeProduct.instances).pipe(
        tap(resp => {
        }),
        catchError(resp => {
          this.requestErrorMessage = TranslationUtils.getTaskErrorMessage("REGISTERED_SERVERS", undefined);
          this.requestFailed = true;
          this.isValidating = false;
          return of(resp);
        })).subscribe();
  }

  processRegisteredServersResponse(msg: MsgPayLoad): void {
    this.registeredServersTask = JSON.parse(msg.body.msg);
    this.registeredServersTask.success = true;
    if (this.registeredServersTask.completed && !this.registeredServersTask.success) {
      if (this.registeredServersTask.errorCode == 'ORPHANED_SERVERS_FOUND') {
        this.registeredServerError = $localize`Orphaned servers were found`;
      } else if (this.registeredServersTask.errorCode == 'ERROR_VALIDATE_REG_SERVERS') {
        this.registeredServerError = $localize`Unable to get registered servers. Please check Content Server logs.`;
      } else if (this.registeredServersTask.data) {
        this.registeredServerError = '';
        this.registeredServerCheck = JSON.parse(this.registeredServersTask.data);
      }

      if (this.registeredServerCheck.additionalHosts.length > 0 || this.registeredServerCheck.missingHosts.length > 0) {

        //flag all instances as error
        this.preReqTableRows.forEach((row: DataTableRow) => {
          row.error = true;
        });
        this.recountSelectedRow = !this.recountSelectedRow;
      }
      this.isValidating = false;
      this.isError = true;
    } else if (this.registeredServersTask.completed && this.registeredServersTask.success) {
      this.preFlightRequest = new PreFlightRequest(
        this.activeProduct.supportHotfix, this.setupId,
        this.activeProduct.pluginId, this.csInfo.token,
        this.csInfo.restUrl, this.platform,
        this.activeUpdate.status != 'INSTALLED' ? this.activeUpdate.id.toString() : undefined,
        this.activeUpdate.status != 'INSTALLED' ? this.activeUpdate.name : undefined,
        [],
        this.removePackageList,
        [],
        this.activeProduct.instances,
        this.activeProduct.groupId,
        +this.activeProduct.patchLevel,
        this.activityCapabilities,
        new Map<string, UpgradePrompt>(),
        []);
      this.preFlightRequest.currentUpdateId = this.activeUpdate.id;
      this.preFlightRequest.currentUpdateName = this.activeUpdate.name;
      this.siService.sendPreFlight(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
        this.preFlightRequest).pipe(
          tap(resp => {
          }),
          catchError(resp => {
            this.processSendPreFlightError(resp);
            this.isValidating = false;
            this.requestErrorMessage = TranslationUtils.getTaskErrorMessage("PRE_FLIGHT", undefined);
            this.requestFailed = true;
            return of(resp);
          })).subscribe();
    }
  }

  processPreFlightMessage(msg: MsgPayLoad) {
    let preFlightTask: PreFlightProgressTask = JSON.parse(msg.body.msg);
    let isPreFlightWarning: boolean = false;
    this.canInstallWithZeroDownTime = preFlightTask.canInstallWithZeroDownTime;

    if (preFlightTask && preFlightTask.status.completed) {
      preFlightTask.progress.forEach((progress: PreFlightProgress) => {
        let row = this.getValidationRow(progress.systemName, progress.instance);

        if (row) {
          if (progress.status.completed) {
            row.data.progress = progress;

            if (progress.status.success) {

              if (progress.status.warning) {
                isPreFlightWarning = true;
                row.showWarningIcon = true;
                row.errorText = $localize`View warnings`;
              } else {
                row.error = false;
                row.showSuccessIcon = true;
              }

              let checks: PreFlightCheck[] = progress.checks.filter((check: PreFlightCheck) => {
                return check.type == PreFlightCheckType.SYSTEM_ANALYSIS;
              });

              if (checks.length > 0) {
                this.analysisVersion = checks[0].dataJson.version;
              }

              row.data.actions = $localize`View details`;
            } else {
              row.data.actions = $localize`View errors`;
              row.error = true;
              row.errorText = $localize`View errors`;
            }
          }
        }
      });

      //check all rows
      let isCompleted: boolean = true;
      let isSuccess: boolean = true;

      this.preReqTableRows.forEach((row: DataTableRow) => {
        if (row.error) {
          isSuccess = false;
        }
        if (row.data.progress == undefined || !row.data.progress.status.completed) {
          isCompleted = false;
        }
      });

      this.isValidated = isSuccess;
      this.isValidating = !isCompleted;
      this.recountSelectedRow = !this.recountSelectedRow;
      this.isValidationWarning = isPreFlightWarning;
    }
  }

  showPreReqErrorDetails(mode: string) {
    Utils.showPreReqErrorDetails(mode, this.registeredServerCheck, this.csInfo, this.primaryInstance, this.modal, this.dataService);
  }

  processSendPreFlightError(data: any): void {
    if (data !== undefined) {
      let keys: string[] = Object.keys(data.error);
      if (keys !== undefined && keys.length > 0) {
        keys.forEach(key => {
          data.error[key].forEach(instance => {
            if (!instance.preFlightSent) {
              let preFlightRow = this.getPrereqRow(instance.systemName, instance.installPath);
              let status: TaskStatus = new TaskStatus();
              status.completed = true;
              status.success = false;
              preFlightRow.data.progress = {};
              preFlightRow.data.progress.status = status;
              preFlightRow.error = true;
            }
          });
        });
      }
    }

    this.requestErrorMessage = TranslationUtils.getTaskErrorMessage("PRE_FLIGHT", undefined);
    this.requestFailed = true;
  }

  viewValdationDetails(row: DataTableRow): void {
    this.modal.open(PreReqCsErrorComponent, {
      data: { progress: row.data.progress },
      id: 'otsc-pre-req-details'
    });
  }

  getValidationRow(systemName: string, installPath: string): DataTableRow {
    let row: DataTableRow;

    let foundRow: DataTableRow[] = this.preReqTableRows.filter((row: DataTableRow) => {
      return row.data.system == systemName && row.data.installPath == installPath;
    });

    if (foundRow.length > 0) {
      row = foundRow[0];
    }

    return row;
  }

  showPatchRemovalWarning(): void {
    const sub: Subscription =
      this.modal.open(DeployUpdateComponent, {
        data: {
          plugin: this.activeProduct.pluginId,
          zeroDownTimeSupported: true,
          canInstallWithZeroDownTime: true,
          instanceCount: this.instanceCount,
          deploymentType: 1
        },
        id: 'otsc-products-patch-remove-confirm-msg'
      }).afterClosed.subscribe((result: DeployUpdateResult) => {
        if (result.deploy) {
          this.patchRemovalActivity.installTaskType = result.installationType;
          this.isPatchRemovalInProgress(true);
        }
        sub.unsubscribe();
      });
  }

  startPatchRemoval(): void {
    this.isSendingPatchRemoval = true;
    this.requestFailed = false;
    this.requestErrorMessage = "";
    this.patchRemovalActivity.token = this.csInfo ? this.csInfo.token : undefined;
    this.patchRemovalActivity.restUrl = this.csInfo ? this.csInfo.restUrl : undefined;
    this.patchRemovalActivity.userName = this.csInfo ? this.csInfo.userName : undefined;
    this.patchRemovalActivity.password = this.csInfo ? this.csInfo.password : undefined;

    let bannerMsg: MsgPayLoad;
    this.siService.startPatchRemoveActivity(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
      this.patchRemovalActivity).pipe(
        tap(resp => {
          this.isActivityRunning = true;
          this.taskInProgress = true;
        }),
        catchError(resp => {
          this.isActivityRunning = false;
          this.showRetry = true;
          this.requestFailed = true;
          this.requestErrorMessage = $localize`Error running remove patch task. Please try again later.`;
          return of(resp);
        }),
        finalize(() => {
          this.isSendingPatchRemoval = false;
        })
      ).subscribe();
  }

  isPatchRemovalInProgress(starting: boolean): void {
    if (this.activeProduct) {
      let systems: string[] = [];
      Object.keys(this.activeProduct.instances).forEach(key => {
        if (this.activeProduct.instances[key]) {
          systems.push(key);
        }
      });
      
      this.activityService.isTargetSystemsBusy(systems).pipe(
        tap(resp => {
          if (resp.body) {
            this.taskInProgress = true;
            if (starting) {
              this.modal.open(ModalMessageComponent, {
                data: {
                  title: systems.length == 1 ? $localize`Agent busy` : $localize`Agents busy`,
                  type: ModalMessageType.Error,
                  message: systems.length == 1 ? $localize`The required agent is currently busy running another task, please try again later.` :
                    $localize`One or more required agents are currently busy running another task, please try again later.`,
                  primaryBtn: $localize`Close`,
                  width: '350px'
                },
                id: 'otsc-products-remove-patch-agent-busy-msg'
              });
            }
          } else {
            if(starting) {
              this.setState(ProductInstalledState.REMOVE);
              this.startPatchRemoval();
            }
          }
        })
      ).subscribe();
    } else {
      setTimeout(() => {
        this.isPatchRemovalInProgress(starting);
      }, 50);
    }
  }

  retry() {
    if (this.state == ProductInstalledState.REMOVE) {
      this.showRetry = false;
      this.startPatchRemoval();
    }
  }

  goToActivitiesOverview(): void {
    this.router.navigate(['/activities/overview']);
  }

  toggleExportMenu(): void {
    setTimeout(() => {
      this.isExportBtnClicked = !this.isExportBtnClicked;
    }, 0);
  }

  showExportConfirmation(type: string): void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Export metadata`,
          message: type == 'csv' ? $localize`Metadata on this page will be downloaded as a CSV file. Download the metadata?` :
            $localize`Metadata on this page will be downloaded as a web page. Download the metadata?`,
          primaryBtn: $localize`Download`,
          secondaryBtn: $localize`Cancel`,
          width: '350px'
        },
        id: 'otsc-products-deployment-export-metadata-msg'
      }
      ).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          this.exportMetadata(type);
        }
        sub.unsubscribe();
      });
  }

  exportMetadata(type: string): void {
    this.siService.exportDeploymentMetadata("patch removal", [], this.langPacksToInstall, this.removePackageList, type, this.patchRemovalActivity.patchesToReApply,
      "", this.patchRemovalActivity.filesToReplaceFromUpdate).pipe(
        tap(resp => {
          let msg: MsgPayLoad;

          if (resp.body.status && resp.body.status.success) {
            msg = new MsgPayLoad(undefined, {
              message: $localize`Metadata was exported successfully. Please check your download folder.`
            });
            msg.setEvent(Events.SuccessMsg);
            setTimeout(() => {
              window.open(resp.body.result.data.url, "_blank");
            }, 500);
          } else {
            msg = new MsgPayLoad(undefined, {
              message: $localize`Metadata failed to exported. See the log for details.`
            });
            msg.setEvent(Events.ErrorMsg);
          }

          Utils.addHeaderMessageBanner(this.eventService, msg);
        })).subscribe();
  }
}
